import { useMemo, useState } from "react";

import { Select, Stack, TextInput } from "../../ui";

export interface AlertEntityOption {
  label: string;
  value: string;
}

export interface AlertRuleEntityOptions {
  agents: AlertEntityOption[];
  agentVersions: AlertEntityOption[];
  batches: AlertEntityOption[];
  markers: AlertEntityOption[];
  templates: AlertEntityOption[];
}

export interface AlertEntitySelectProps {
  disabled?: boolean;
  emptyLabel?: string;
  label: string;
  onChange: (value: string) => void;
  options: AlertEntityOption[];
  required?: boolean;
  value: string;
}

export function AlertEntitySelect({
  disabled = false,
  emptyLabel = "All",
  label,
  onChange,
  options,
  required = false,
  value,
}: AlertEntitySelectProps) {
  const [query, setQuery] = useState("");
  const filteredOptions = useMemo(() => {
    const normalized = query.trim().toLocaleLowerCase();
    if (normalized.length === 0) {
      return options;
    }
    const matches = options.filter((option) =>
      option.label.toLocaleLowerCase().includes(normalized),
    );
    const selected = options.find((option) => option.value === value);
    return selected && !matches.includes(selected)
      ? [selected, ...matches]
      : matches;
  }, [options, query, value]);

  return (
    <Stack gap={2}>
      <TextInput
        disabled={disabled}
        label={`${label} search`}
        placeholder={`Search ${label.toLocaleLowerCase()}…`}
        type="search"
        value={query}
        onChange={(event) => {
          setQuery(event.currentTarget.value);
        }}
      />
      <Select
        disabled={disabled}
        emptyLabel={
          required ? `Select ${label.toLocaleLowerCase()}` : emptyLabel
        }
        label={label}
        required={required}
        value={value}
        onChange={(event) => {
          onChange(event.currentTarget.value);
        }}
      >
        {required ? null : <option value="">{emptyLabel}</option>}
        {filteredOptions.map((entityOption) => (
          <option key={entityOption.value} value={entityOption.value}>
            {entityOption.label}
          </option>
        ))}
      </Select>
    </Stack>
  );
}
